import React, { useState, useEffect } from 'react';
import { FaEnvelope, FaEye, FaEyeSlash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import apis from '../services';
import { useDispatch } from 'react-redux';
import { setUser } from '../redux/userSlice';
import { SyncLoader } from 'react-spinners';
function Login() {
  const navigate = useNavigate();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    const savedEmail = localStorage.getItem('rememberedEmail');
    const savedPassword = localStorage.getItem('rememberedPassword');
    if (savedEmail) {
      setEmail(savedEmail);
      setRememberMe(true); 
    }
    if (savedPassword) {
      setPassword(savedPassword);
    }
  }, []);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const handleRememberMeChange = (e) => {
    setRememberMe(e.target.checked);
  };

  // const handleLogin = async (e) => {
  //   e.preventDefault();

  //   try {
  //     const body = { email, password };
  //     const response = await apis.authLogin(body);


  //     dispatch(setUser(response.data.user));

  //     if (response?.data?.user?._id) {
  //       if (rememberMe) {
         
  //         localStorage.setItem('rememberedEmail', email);
  //         // localStorage.setItem('rememberedPassword', password); commit at 9-1-2025
  //       } else {
  //         localStorage.removeItem('rememberedEmail');
  //         localStorage.removeItem('rememberedPassword');
  //       }
  //       localStorage.setItem('userId', response.data.user._id);
  //       toast.success('User login successfully');
  //       setTimeout(() => {
  //         if (response?.data?.status) {
  //           navigate('/home');
  //         }
  //       }, 1000); 
  //     } else {
  //       toast.error('User ID not found in response data');
  //     }
  //   } catch (error) {
  //     // toast.error('Error during login:', error);
  //     if (error.response && (error.response.status === 500 || error.response.status === 404)) {
  //       toast.error('Invalid Credentials');
  //     } else {
  //       toast.error(error.response?.data?.message || 'Something went wrong, please try again');
  //     }
  //   }
  // };
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true); // show loader
  
    try {
      const body = { email, password };
      const response = await apis.authLogin(body);
  
      dispatch(setUser(response.data.user));
  
      if (response?.data?.user?._id) {
        if (rememberMe) {
          localStorage.setItem('rememberedEmail', email);
        } else {
          localStorage.removeItem('rememberedEmail');
          localStorage.removeItem('rememberedPassword');
        }
  
        localStorage.setItem('userId', response.data.user._id);
        toast.success('User login successfully');
  
        setTimeout(() => {
          setLoading(false); // optional, if navigate is instant
          if (response?.data?.status) {
            navigate('/home');
          }
        }, 1000);
      } else {
        setLoading(false);
        toast.error('User ID not found in response data');
      }
    } catch (error) {
      setLoading(false); // stop loader
      if (error.response && (error.response.status === 500 || error.response.status === 404)) {
        toast.error('Invalid Credentials');
      } else {
        toast.error(error.response?.data?.message || 'Something went wrong, please try again');
      }
    }
  };
  
  return (
    <div className="login-background">
      <h2 className="app-title">Lookna</h2>
      <div className="login-box">
        <h3 className="login-heading">Please Login</h3>
        <form className="login-form" onSubmit={handleLogin}>
          <div className="input-group">
            <FaEnvelope className="input-icon" />
            <input
              type="email"
              placeholder="Email"
              required
              className="input-field"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="input-group">
            <span onClick={togglePasswordVisibility} className="password-toggle-icon">
              {passwordVisible ? <FaEye className="input-icon" /> : <FaEyeSlash className="input-icon" />}
            </span>
            <input
              type={passwordVisible ? 'text' : 'password'}
              placeholder="Password"
              required
              className="input-field"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="remember-me">
            <input
              type="checkbox"
              id="rememberMe"
              checked={rememberMe}
              onChange={handleRememberMeChange}
            />
            <label htmlFor="rememberMe">Remember Me</label>
          </div>
          {/* <button type="submit" className="login-button">Login</button> */}
          <button
  type="submit"
  className="login-button"
  disabled={loading}
  style={{
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    cursor: loading ? 'not-allowed' : 'pointer',
    opacity: loading ? 0.7 : 1
  }}
>
  {loading ? (
    <>
<SyncLoader color="white"  size={9} />

      {/* Logging in... */}
    </>
  ) : (
    'Login'
  )}
</button>


        </form>
      </div>
    </div>
  );
}
export default Login;
